import React, { useEffect, useLayoutEffect, useState } from 'react';
import RadioGroup from 'components/partials/Fields/RadioGroup';
import Button from 'components/partials/Fields/Button';
import { useService } from 'hooks/useService';
import { POST } from 'services/RequestMethods';
import { general_error_toastr } from 'components/partials/Notification';
import { delay } from 'lodash';
import { connect } from 'react-redux';
import { setVerificationQuestionsStatus } from 'actions';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from 'react-bootstrap/ModalHeader';
import ModalTitle from 'react-bootstrap/ModalTitle';
import ModalFooter from 'react-bootstrap/ModalFooter';
import ModalBody from 'react-bootstrap/ModalBody';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const IdentityVerification = ({
    user_id,
    reg_type,
    questions = [],
    redirect,
    getQuestions,
    setVerificationQuestionsStatus,
}) => {
    const [step, setStep] = useState(0);
    const [value, setValue] = useState(null);
    const [answers, setAnswers] = useState([]);
    const [showRequiredError, setShowRequiredError] = useState(false);
    const [showFailedModal, setShowFailedModal] = useState(false);
    const [retryLoading, setRetryLoading] = useState(false);
    const [numRetry, setNumRetry] = useState(0);
    const [{ loading }, fireCheck] = useService();

    const setAnswerArray = () => {
        setAnswers([...answers, {
            question_id: questions[step].question_id,
            answer: value,
        }]);
    };

    const handleChange = v => setValue(v);

    const handleNextQuestion = () => {
        setValue(null);
        setStep(step + 1);
    };

    const handleFailedQuestions = () => {
        setVerificationQuestionsStatus('failed');
        redirect();
    };

    const handleSubmit = () => async () => {
        if (!value) {
            return setShowRequiredError(true);
        }

        if (step !== 4) {
            setAnswerArray();
            return handleNextQuestion();
        }

        if (numRetry === 2) {
            return;
        }

        try {
            const { correct } = await fireCheck({
                url: 'users/check/identity',
                method: POST,
                params: {
                    user_id,
                    reg_type,
                    questions: [
                        ...answers,
                        {
                            question_id: questions[step].question_id,
                            answer: value,
                        },
                    ],
                },
            });

            if (!correct) {
                numRetry === 0 ? setShowFailedModal(true) : handleFailedQuestions();
                return setNumRetry(numRetry + 1);
            } else {
                setVerificationQuestionsStatus('correct');
                return redirect();
            }
        } catch (e) {
            general_error_toastr();
        }
    };

    const handleRetry = async () => {
        setRetryLoading(true);
        await getQuestions({ part: 2 });
        setStep(0);
        setAnswers([]);
        setValue(null);
        setShowFailedModal(false);
        delay(() => setRetryLoading(false), 1000);
    };

    useEffect(() => {
        if (value) {
            setShowRequiredError(false);
        }
    }, [value]);

    useLayoutEffect(() => {
        scrollTo(0, 0);
    }, []);

    if (questions) {
        return (
            <>
                <Modal show={showFailedModal}>
                    <ModalHeader>
                        <ModalTitle>Identity Verification Mismatch</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <p>
                            Unfortunately, the information provided resulted in a mismatch.
                            User account not registered.
                        </p>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            onClick={handleRetry}
                            variant="primary"
                            label="Retry"
                            loading={retryLoading}
                            disabled={retryLoading}
                        />
                    </ModalFooter>
                </Modal>
                <form>
                    <Row>
                        <h2 className="section-title">
                            Identity Verification
                        </h2>
                    </Row>
                    <div className="field-container">
                        <Col md={12} className="mb-5">
                            We value your security when registering on our website.
                            In order to verify that users provide accurate
                            information, we use identify verification. Please answer
                            the following questions to confirm your identity.
                            <br />
                            <br />
                            For each question, there is only 1 right answer.
                            <br />
                            <br />
                            <p>{questions[step]?.question_label}</p>
                            <RadioGroup
                                required
                                name={questions[step]?.question_id}
                                value={value}
                                updateMethod={({ target: { value } }) => {
                                    handleChange(value);
                                }}
                                options={questions[step]?.question_options.map(o => ({ value: o, label: o }))}
                            />
                            {showRequiredError &&
                                <div className="help-block error-text">
                                    Please select an answer.
                                </div>
                            }
                        </Col>
                    </div>
                    <Row className="d-flex justify-content-center">
                        <Col md={3}>
                            <Button
                                label={step === 4 ? 'Submit' : 'Next question'}
                                loading={loading}
                                disabled={loading}
                                onClick={handleSubmit(questions[step]?.question_id)}
                            />
                        </Col>
                    </Row>
                </form>
            </>
        );
    }
};

const bindings = { setVerificationQuestionsStatus };

export default connect(() => { }, bindings)(IdentityVerification);